import { getColorAlias } from '../../utils/index.js';

const getLinkColor = (variant) => {
    switch (variant) {
        case 'default':
            return getColorAlias('contentLink');
        case 'high-visibility':
            return getColorAlias('contentLinkDistinct');
        case 'inversion':
            return getColorAlias('contentLinkInverse');
        default:
            console.warn('Error, incorrect props. Pass the correct set of props to the getLinkColor function.');
    }
};

export { getLinkColor };
